import { ca } from '@cian/analytics';

export const trackErrorModalOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Show',
    label: 'BrokerDealPopUpFail',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
};
